// Components
import { Button, mergeClasses, Tooltip } from "@fluentui/react-components";
// Styles
import { useIconButtonStyles } from "./IconButton.styles";
// Utilities
import * as React from "react";
/**
 * IconButton control that customizes the fluent control to our own purposes
 */ export const IconButton = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const { title, ...propsWithoutTitle } = props;
    const classNames = useIconButtonStyles();
    const root = mergeClasses(classNames.root, props.className);
    let component;
    if (title) {
        // Use the title in a Fluent tooltip for accessibility.
        component = /*#__PURE__*/ React.createElement(Tooltip, {
            content: title,
            relationship: "label"
        }, /*#__PURE__*/ React.createElement(Button, {
            "data-testid": "icon-button",
            ...propsWithoutTitle,
            className: root,
            ref: ref
        }));
    } else {
        component = /*#__PURE__*/ React.createElement(Button, {
            "data-testid": "icon-button",
            ...props,
            className: root,
            ref: ref
        });
    }
    return component;
});
